import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { debounce } from '../../../utils/utils';
// import queryParser from 'query-string';
import common from '../../../common/common';
import intl from 'react-intl-universal';
import { Base64 } from 'js-base64';
import styles from './watermark.module.scss';

const percent2percent25 = (URI) => {
  if (URI.indexOf('%') > -1) return URI.replace(/%/g, '%25');
  else return URI;
}
const searchParam = common.getSearchParam() || {};
let nickName = '';
// if (JSON.stringify(searchParam) !== '{}') {
//   let base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
//   nickName = searchParam.nickName;
//   if (!nickName)  {
//     nickName = '';
//   } else if (!!nickName.match(base64Regex)) {
//     nickName = Base64.decode(searchParam.nickName);
//     nickName = decodeURIComponent(decodeURI(percent2percent25(nickName)));
//   } else {
//     nickName = '';
//   }
// }
// console.log('nickName: ', nickName);
class Watermark extends Component {
  ranTimer = null;
  delayTimer = null;
  firstRef = React.createRef();
  secondRef = React.createRef();
  w1 = 0;
  h1 = 0;
  w2 = 0;
  h2 = 0;
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      l1: 0,
      t1: 0,
      l2: 0,
      t2: 0
    }
  }

  componentDidMount() {
    this.w1 = parseInt(getComputedStyle(this.firstRef.current).width);
    this.h1 = parseInt(getComputedStyle(this.firstRef.current).height);
    this.w2 = parseInt(getComputedStyle(this.secondRef.current).width);
    this.h2 = parseInt(getComputedStyle(this.secondRef.current).height);
    this.do();
    window.addEventListener('resize', this.lastDo);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.lastDo);
  }

  do = () => {
    this.delayTimer && clearTimeout(this.delayTimer);
    this.ranTimer && clearTimeout(this.ranTimer);
    const body = document.querySelector('body');
    const bodyW = parseInt(getComputedStyle(body).width);
    const bodyH = parseInt(getComputedStyle(body).height);
    let l1 = Math.random() * (bodyW - this.w1);
    let t1 = Math.random() * (bodyH - this.h1);
    let l2 = Math.random() * (bodyW - this.w2);
    let t2 = Math.random() * (bodyH - this.h2);
    if (t2 >= t1) {
      if (t2 - t1 < this.h1) {
        t2 = t1 + this.h1;
      }
    } else {
      if (t1 - t2 < this.h2) {
        t1 = t2 + this.h2;
      }
    }

    this.setState({
      show: true,
      l1,
      t1,
      l2,
      t2
    }, () => {
      this.delayTimer = setTimeout(() => {
        this.setState({
          show: false
        }, () => {
          this.ranTimer = setTimeout(() => {
            this.do();
          }, 15000 + Math.round(Math.random() * 10) * 1000)
        })
      }, 5000)
    })
  }

  lastDo = debounce(this.do, 1000);

  render() {
    const { show, l1, t1, l2, t2 } = this.state;

    return ReactDOM.createPortal(
      <>
        <div style={{ visibility: show ? 'visible' : 'hidden', left: l1 + 'px', top: t1 + 'px' }} className={styles.waterMark} ref={this.firstRef}>
          {/* {window.location.host.includes('metcom') ? '' : intl.get('REPLAY_KNOWLEDGE_POINT_XDF')} {nickName} {searchParam.uid} */}
          {searchParam.uid}
        </div>
        <div style={{ visibility: show ? 'visible' : 'hidden', left: l2 + 'px', top: t2 + 'px' }} className={styles.waterMark} ref={this.secondRef}>
          {/* {window.location.host.includes('metcom') ? '' : intl.get('REPLAY_KNOWLEDGE_POINT_XDF')} {nickName} {searchParam.uid} */}
          {searchParam.uid}
        </div>
      </>,
      document.getElementById('knowledgePointPlayback') || document.querySelector('body')
    )
  }
}

export default Watermark;
